/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_PlaceholderInputs */



/**
* | output |
* | --- |
* | "untitled" |
*
* @param {Explorer_Display_New_Folder_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_placeholder = /** @type {((inputs?: Explorer_Display_New_Folder_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("sans titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("ohne Titel")
	if (locale === "it") return /** @type {LocalizedString} */ ("senza titolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("без названия")
	if (locale === "es") return /** @type {LocalizedString} */ ("intitulado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無題")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्षकहीन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("sem título")
	return /** @type {LocalizedString} */ ("untitled")
});